const en = {
  greeting: 'Welcome',
  label_btn_details: 'Details',
  pagination: {
    First: '«',
    Prev: 'Previous',
    Next: 'Next',
    Last: '»',
  },
  pagenotfound: {
    title: 'Page Not Found',
    desc: "We're sorry, we couldn't find the page you requested.",
  },
  header_bar: {
    link_home: {
      name: 'HKTDC.com',
      url: 'http://www.hktdc.com',
    },
    link_about: {
      name: 'About HKTDC',
      url: 'http://aboutus.hktdc.com/en',
    },
    title_login: 'Login',
    title_logout: 'Logout',
    title_edit_profile: 'Edit Profile',
    title_register: 'Register',
    title_myhktdc: 'My HKTDC',
    txt_back: 'Back',
    link_myhktdc: 'https://home.hktdc.com/en/myhktdc',
  },
  speaker: {
    popup: {
      remark: '* For high-resolution photos, please click the images.',
    },
  },
  under_construction: {
    text: 'To be available soon',
  },
  loading: 'LOADING',
  search: {
    placeholder: 'Exhibitors/ Suppliers/ Products/ Booth no./ Brands',
    validation: 'Please enter a keyword!',
  },
  sbeProgramme: {
    venue: 'Venue',
    language: 'Language',
    remarks: 'Remarks',
    hkTimezone: 'HKT',
  },
  photo: {
    view: 'view',
    download: 'download',
  },
  video: {
    date: 'Date',
    duration: 'Duration',
    close: 'Close',
  },
};

export default en;
